import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from "react";
import Header from "../../../components/header/header";
import { Button } from "../../../components/button";
import Footer from "../../../components/footer";
import {BackBtn} from "../../../components/header/btn/back-btn";

function WelcomePage() {
    const { state } = useLocation()
    const navigate = useNavigate();

    useEffect(() => {
        if (!state || !("cardUuid" in state)) {
            navigate("/not-found")
        }
    }, [])

    const redirectToProfileEdit = () => {
        navigate("/profile-link-generate", { state: state })
    }

    return (
        <div className='Layer'>
            <Header>
                <BackBtn onClick={() => navigate(-1)} />
            </Header>
            <div className="Layer-inner">
                <div className="contents-container">
                    <img src='/assets/img/logo.svg' alt={""} style={{height:'45px',margin:'0 0 0 24px','align-self':'baseline'}}/>
                    <div className='title-container'>가입을 축하합니다!</div>
                </div>
                <div className='primary-btn-container'>
                    <Button onClick={redirectToProfileEdit}>
                        프로필 작성하기
                    </Button>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default WelcomePage;
